import * as React from 'react';
export const TaxDeduction = ({ className, margin, color, align, font, linkInner }) => {
  return (
    <p
      className={className}
      style={{
      margin: margin,
      color: color,
      textAlign: align,
      fontSize: font,
      position: "relative",
      zIndex: "999"
    }}>
      При покупке курсов Advance вы&nbsp;можете получить <a href={linkInner ? "/info/tax_deduction_13_inner/" : "/info/tax_deduction_13/"} target={"_blank"} rel={"noreferrer"} style={{ textDecoration: "underline", color: "inherit" }}>налоговый&nbsp;вычет 13%</a>
    </p>
  );
};
